
import React, { useState, useEffect, useContext } from 'react';
import { EnvironmentContext } from '../../EnvironmentContext';
import Tabs from '../../Components/Tabs/Tabs';
import { Toolbar } from "@mui/material";
import { DataGridComponent, PageSizeCustomOptions } from "../../Components/PaginationComponent";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import './ContentManagement.css'
import { PaginationComponent } from '../../Components/PaginationComponent';
import APIServices from '../../services/APIServices';
import { useDispatch } from 'react-redux';
import { Backdrop, CircularProgress } from '@mui/material';
import ButtonCompo from '../../Components/ButtonComponent/ButtonCompo';
import RenderReviews from './RenderReviews';
import AlertComponent from '../../Components/Alert/Alert';
import apiconfig from '../../config/config';
import RenderHomeImages from './RenderHomeImages';
import moment from 'moment';
import { setAccessToken } from '../../Redux/Actions';
import { useNavigate } from 'react-router-dom';
import DialogComponentSingleBtn from '../../Components/Dialog/DialogComponentSingleBtn';


const ContentManagement = ({ typeOfBtn, buttonText }) => {
    const { environment } = useContext(EnvironmentContext)
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [updateEvent, setUpdateEvent] = useState(null);
    const [errAlert, setErrAlert] = useState(false);
    const [popularTripAddedAlert, setPopularTripAddedAlert] = useState(false)
    const [popularTripRemoveAlert, setPopularTripRemoveAlert] = useState(false)
    const [popularTripsAlert, setPopularTripsAlert] = useState(false)
    const accessToken = useSelector((state) => state.accessToken);
    const [EventsData, setEventsData] = useState([])

    const adminDetails = useSelector((state) => state?.loginUserDetails);
    // const adminUserId = adminDetails?._id

    const adminMail = adminDetails?.mail
    const testingEnvironmentIds = {
        "support@meetbytravel.com": "669f4adac194ae7c8eb65d50",
        "jayadeep.mettela@ro-one.in": "665d4b21e27fc43df3215575"
    };

    const productionEnvironmentIds = {
        "support@meetbytravel.com": "669f4b370e0130ee414ef469",
        "jayadeep.mettela@ro-one.in": "66750b795ec6ba4ed5e33656"
    };

    let adminUserId;
    if (environment === "Production") {
        adminUserId = productionEnvironmentIds[adminMail];
    } else if (environment === "Testing") {
        adminUserId = testingEnvironmentIds[adminMail];
    }


    useEffect(() => {
        const tokenLocal = JSON.parse(localStorage.getItem("token"));
        if (!accessToken && tokenLocal) {
            dispatch(setAccessToken(tokenLocal));
            APIServices.setAuthToken(tokenLocal);
        } else if (!accessToken && !tokenLocal) {
            navigate("/login");
        }
        if (accessToken || tokenLocal) {
            const tokenToUse = accessToken || tokenLocal;
            setIsLoading(true);
            APIServices.setAuthToken(tokenToUse);
            const url = environment === "Production"
                ? apiconfig.production.apiBaseUrl
                : apiconfig.develpoment.apiBaseUrl;

            APIServices.setApiBaseUrl(url);


            APIServices.getEventsCounts()
                .then((response) => {
                    setEventsData(response?.data?.UpcomingEvents)
                    setIsLoading(false)
                })
                .catch((err) => {
                    setErrAlert(true)
                    console.log("Error While Fetching All Events: ", err);
                    setIsLoading(false)
                });
        }
    }, [updateEvent, dispatch, environment, accessToken, navigate]);

    const filteredUpcomingTrips = EventsData?.filter((hit) => {
        const startDate = hit?.start_date;
        const startTime = hit?.start_time;
        const timeZone = hit?.time_zone;
        let convertedTimeZone = timeZone;
        if (timeZone === "IST") {
            convertedTimeZone = "Asia/Kolkata";
        }
        const covertedStartDateAndTime = moment.tz(
            startDate + " " + startTime,
            "YYYY-MM-DD HH:mm",
            convertedTimeZone
        );

        const currentDateAndTime = moment.tz(convertedTimeZone);
        return (
            hit.save_draft === false &&
            covertedStartDateAndTime.isAfter(currentDateAndTime) &&
            hit.event_status !== "cancelled"

        );
    });

    const popularTripsArray = filteredUpcomingTrips?.filter((eachEvent) => {
        return eachEvent?.popular_trip === true
    })


    const renderPopularTrips = () => {
        const columnsOfPopularTrips = [
            {
                field: "EventId",
                headerName: "Event ID",
                width: 150,
                headerClassName: "custom-header",
                renderCell: (params) => (
                    <Link
                        to={`/event-management/event/${params.value}`}
                        style={{ color: "#0B63F8", fontFamily: "poppins" }}
                    >
                        {params.value}
                    </Link>
                ),
            },
            {
                field: "Tripdate",
                headerName: "Trip date",
                width: 150,
                cellClassName: "fullname-cell",
                headerClassName: "custom-header",
            },

            {
                field: "TripOrganiser",
                headerName: "Trip Organiser",
                width: 250,
                cellClassName: "email-cell",
                headerClassName: "custom-header",
            },
            {
                field: "Triptitle",
                headerName: "Trip title",
                width: 350,
                cellClassName: "organiser-status-cell",
                headerClassName: "custom-header",
            },
            {
                width: 150,
                display: "flex",
                alignItems: "center",
                renderCell: (params) => (
                    <ButtonCompo btnOutlined
                        btnText="Remove"
                        onClick={() => handleRemoveButtonClick(params?.row?.EventId, params.row?.ids)}
                    />


                ),
            },
        ];

        const rowsOfPopularTrips = popularTripsArray?.map((item, index) => ({
            id: index,
            EventId: item?.ID_event,
            Tripdate: item?.start_date,
            TripOrganiser: item?.organizers,
            Triptitle: item?.trip_title,
            popularTrip: item?.popular_trip,
            ids: item?._id

        }));

        const columns = [
            {
                field: "EventId",
                headerName: "Event ID",
                width: 150,
                headerClassName: "custom-header",
                renderCell: (params) => (
                    <Link
                        to={`/event-management/event/${params.value}`}
                        style={{ color: "#0B63F8", fontFamily: "poppins" }}
                    >
                        {params.value}
                    </Link>
                ),
            },
            {
                field: "Tripdate",
                headerName: "Trip date",
                width: 150,
                cellClassName: "fullname-cell",
                headerClassName: "custom-header",
            },

            {
                field: "TripOrganiser",
                headerName: "Trip Organiser",
                width: 250,
                cellClassName: "email-cell",
                headerClassName: "custom-header",
            },
            {
                field: "Triptitle",
                headerName: "Trip title",
                width: 350,
                cellClassName: "organiser-status-cell",
                headerClassName: "custom-header",
            },
            {
                width: 150,
                display: "flex",
                alignItems: "center",
                renderCell: (params) => {
                    return params.row.popularTrip ? (
                        <ButtonCompo
                            disabledButton
                            btnText="Add +"
                        />
                    ) : (
                        <ButtonCompo btnOutlined
                            btnText="Add +"
                            onClick={() => handleAddButtonClick(params?.row?.EventId, params.row?.ids, params?.row?.popularTrip)}
                        />



                    )
                }
            },
        ];


        const rows = filteredUpcomingTrips?.map((item, index) => ({
            id: index,
            EventId: item?.ID_event,
            Tripdate: item?.start_date,
            TripOrganiser: item?.organizers,
            Triptitle: item?.trip_title,
            popularTrip: item?.popular_trip,
            ids: item?._id
        }));



        const handleAddButtonClick = (eventIdSelected, ids, popularTrip) => {
            setIsLoading(true);
            // if (popularTripsArray.length >= 20) {
            //     console.log("More than 20")
            //     setPopularTripsAlert(true)
            // } else {
            const body = {
                popular_trip: true,
            };
            APIServices.updateEvent(body, ids, adminUserId)
                .then((response) => {
                    setUpdateEvent(Math.random());
                    setIsLoading(false);
                    setPopularTripAddedAlert(true)
                })
                .catch((err) => {
                    console.log("Getting error while updating the event", err);
                    setIsLoading(false);
                    setErrAlert(true)
                });
            // }
        };

        const handleRemoveButtonClick = (eventIdSelected, ids, popularTrip) => {
            setIsLoading(true);
            const body = {
                popular_trip: false,
            };
            APIServices.updateEvent(body, ids, adminUserId)
                .then((response) => {
                    setUpdateEvent(Math.random());
                    setIsLoading(false);
                    setPopularTripRemoveAlert(true)
                    console.log('body : ', response?.data?.Event)
                })
                .catch((err) => {
                    console.log("Getting error while updating the event", err);
                    setIsLoading(false);
                    setErrAlert(true)
                });

        };
        return (
            <>
                <Backdrop
                    sx={{
                        color: "#ffffff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>


                <AlertComponent
                    open={popularTripAddedAlert}
                    severity="success"
                    onClose={() => setPopularTripAddedAlert(false)}
                    text="Event successfully added to popular trips."
                />


                <AlertComponent
                    open={popularTripRemoveAlert}
                    severity="success"
                    onClose={() => setPopularTripRemoveAlert(false)}
                    text="Event successfully removed from popular trips."
                />

                <AlertComponent
                    open={errAlert}
                    severity="error"
                    onClose={() => setErrAlert(false)}
                    text="Something went wrong.Please try again after sometime."
                />


                <main style={{ flexGrow: 1 }}>
                    <Toolbar />
                    <h4
                        style={{ marginBottom: '40px', fontFamily: 'Poppins', fontSize: '16px', fontWeight: 'bold' }}>Popular Trips</h4>
                    {/* <PageSizeCustomOptions columns={columnsOfPopularTrips} rows={rowsOfPopularTrips} /> */}
                    <DataGridComponent columns={columnsOfPopularTrips} rows={rowsOfPopularTrips} />
                </main>



                <br></br>

                <h4 style={{ marginBottom: '40px', fontFamily: 'Poppins', fontSize: '16px', fontWeight: 'bold' }}>All Events</h4>
                <DataGridComponent columns={columns} rows={rows} />
            </>

        )
    }

    const tabContentManagement = [
        {
            label: "Popular Trips",
            component: renderPopularTrips()
        },
        {
            label: "Homepage Images",
            component: <RenderHomeImages />
        },
        {
            label: "Reviews",
            component: <RenderReviews />
        },
    ];

    const handlePopularTripPopup = () => {
        setPopularTripsAlert(false)
    }
    return (
        <div>
            <Tabs tabItems={tabContentManagement} />
            < DialogComponentSingleBtn
                open={popularTripsAlert}
                title="You can't add more than 20 trips to popular trips"
                leftBtnText="Close"
                // rightBtnClick={handleCancelEvent}
                leftBtnClick={handlePopularTripPopup}
                onClose={handlePopularTripPopup}
            />
        </div>
    )
}

export default ContentManagement;
